import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

export interface GradientTextProps extends React.HTMLAttributes<HTMLDivElement> {
  variant: 'body3' | 'body-strong' | 'body2-strong' | 'h1' | 'body' | 'h2';
  from?: string;
  to?: string;
  gradient?: string;
  children: React.ReactNode;
  asOutline?: string;
}

export default function GradientText({
  variant,
  from = colors.blue30,
  to = colors.pink50,
  className,
  children,
  gradient,
  asOutline,
}: GradientTextProps) {
  const customStyle = {
    background: gradient ? gradient : `linear-gradient(0.25turn, ${from}, ${to})`,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    WebkitTextStroke: asOutline ? asOutline : undefined,
  };

  return (
    <>
      {variant === 'h1' && (
        <h1 className={cn('inline-block tracking-wider', className)} style={customStyle}>
          {children}
        </h1>
      )}
      {variant === 'h2' ? (
        <h2 className={cn('inline-block tracking-wider', className)} style={customStyle}>
          {children}
        </h2>
      ) : null}
      {variant === 'body-strong' && (
        <div className={cn('body-strong inline-block', className)} style={customStyle}>
          {children}
        </div>
      )}
      {variant === 'body' && (
        <div className={cn('body inline-block', className)} style={customStyle}>
          {children}
        </div>
      )}
      {variant === 'body2-strong' && (
        <div className={cn('body2-strong inline-block', className)} style={customStyle}>
          {children}
        </div>
      )}
      {variant === 'body3' && (
        <div
          className={cn('body3-strong inline-block uppercase tracking-wider', className)}
          style={customStyle}
        >
          {children}
        </div>
      )}
    </>
  );
}
